<template>
    <div class="general-setting">
        <app-overlay-loader v-if="preloader"/>
        <form v-else ref="form" data-url="/admin/app/settings" enctype="multipart/form-data"
              class="mb-0"
              :class="{'loading-opacity': preloader}">
            <!-- Company Info -->
            <fieldset class="form-group mb-5">
                <div class="row">
                    <legend class="col-12 col-form-label text-primary pt-0 mb-3">
                        {{ $t('company_info') }}
                    </legend>
                    <div class="col-md-12">
                        <div class="form-group row">
                            <label for="appSettingsCompanyName" class="col-lg-3 col-xl-3 col-form-label">
                                {{ $t('company_name') }}
                            </label>
                            <div class="col-lg-8 col-xl-8">
                                <app-input id="appSettingsCompanyName"
                                           type="text"
                                           v-model="appSettings.company_name"
                                           :placeholder="$t('type_your_company_name')"
                                           :required="true"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="appSettingsCompanyLogo" class="col-lg-3 col-xl-3 col-form-label h-fit-content">
                                {{ $t('company_logo') }}<br>
                                <small class="text-muted font-italic">
                                    {{ $t('recommended_company_logo_size') }}
                                </small>
                            </label>
                            <div class="col-sm-4">
                                <app-input id="appSettingsCompanyLogo"
                                           type="custom-file-upload"
                                           v-model="reqData.company_logo"
                                           :label="$t('change_logo')"/> 
                            </div>
                            <div class="custom-image-upload-wrapper" v-if="appSettings.company_logo">
                                <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="appSettings.company_logo"                           :alt-text="$t('not_found')"/>         
                            </div> 
                        </div>
                        <div class="form-group row">
                            <label for="appSettingsCompanyIcon" class="col-lg-3 col-xl-3 col-form-label h-fit-content">
                                {{ $t('company_icon') }}<br>
                                <small class="text-muted font-italic">
                                    {{ $t('recommended_company_icon_size') }}
                                </small>
                            </label>
                            <div class="col-sm-4">
                                <app-input id="appSettingsCompanyIcon"
                                           type="custom-file-upload"
                                           :generate-file-url="false"
                                           v-model="reqData.company_icon"
                                           :label="$t('change_icon')"/>
                            </div>
                            <div class="custom-image-upload-wrapper" v-if="appSettings.company_icon">
                                <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="appSettings.company_icon"                           :alt-text="$t('not_found')"/>         
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="appSettingsCompanyBanner" class="col-lg-3 col-xl-3 col-form-label h-fit-content">
                                {{ $t('company_banner') }}<br>
                                <small class="text-muted font-italic">
                                    {{ $t('recommended_company_banner_size') }}
                                </small>
                            </label>
                            <div class="col-sm-4">
                                <app-input id="appSettingsCompanyBanner"
                                           type="custom-file-upload"
                                           :generate-file-url="false"
                                           v-model="reqData.company_banner"
                                           :label="$t('change_banner')"/> 
                            </div>
                            <div class="custom-image-upload-wrapper" v-if="appSettings.company_banner">
                                <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="appSettings.company_banner"                           :alt-text="$t('not_found')"/>         
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div class="mt-5 action-buttons">
                <button class="btn btn-primary mr-2" @click.prevent="submit">
                    {{ $t('save') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import {SettingsStoreMixin} from './Mixins/SettingsStoreMixin';
    import * as actions from "../../../Config/ApiUrl";
    export default {
        name: "GeneralSetting",
        mixins: [FormMixin, SettingsStoreMixin],
        data() {
            return {
                preloader: false,
                reqData:{},
            }
        },
        created() {
            this.data();
            this.$store.dispatch('getSettings');
        },
        computed: {
        },
        methods: {
            
            data() {
                this.preloader= true;
                let url = actions.GENERAL_SETTINGS;
                this.axiosGet(url).then(response => {                    
                    this.layouts = response.data.layouts;
                }).catch(({response}) => {
                }).finally(()=>{
                    this.preloader=false;
                });
            },
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.appSettings)) {
                    if (value != null) formData.append(key, value);
                }
                if (this.reqData.company_logo) {
                    formData.append("company_logo", this.reqData.company_logo);
                }
                if (this.reqData.company_icon) {
                    formData.append("company_icon", this.reqData.company_icon);
                }
                if (this.reqData.company_banner) {
                    formData.append("company_banner", this.reqData.company_banner);
                }
                
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
                this.reqData = '';
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
        }
    }
</script>
